import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'store';
import { InviteData, selectInvite } from 'store/invite';

import ProfileImage from '../../../../assets/images/LoginLeftImage.png';
import styles from './ProfileLayout.module.scss';

export const ProfileLayout = () => {
  const { t } = useTranslation('auth');
  const invite: InviteData = useAppSelector(selectInvite)!;

  return (
    <Box className={styles.layoutContainer}>
      <img className={styles.registerImage} src={ProfileImage} />
      <Typography variant='h1' className={styles.createRoomText}>
        {t('createWaitingRoom')}
      </Typography>
      <Box className={styles.layoutItem}>
        <Typography variant='body2' className={styles.createRoomDesc}>
          {t('thisWillBeYourRoomFor', { organization: invite.organizationName })}
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <Typography variant='body2'>{t('roomNameUrlRequiredLong')}</Typography>
      </Box>
    </Box>
  );
};
